import Radio from "backbone.radio";
import { useEffect } from "react";
import { AuthRoute, useRouteMatch, useParams } from "extensions/react-router";

import { SET_STATE_FROM_URL } from "common/actions/email";

import { EmailAnalyticsPage } from "./email";

export function EmailRouter() {
    const { url } = useRouteMatch();
    return (
        <AuthRoute path={`${url}/email/:section?/:qualifiers?`} component={EmailComponent} />
    );
}

function EmailComponent() {
    const { section, qualifiers } = useParams();

    useEffect(() => {
        // TODO MATT: Don't do this. Let it just flow from routing.
        SET_STATE_FROM_URL({ ...section && { section }, ...qualifiers && { qualifiers } });

        Radio.channel("main").request("show:app:view", <EmailAnalyticsPage />, {
            name: "Email analytics",
            waitForAttach: true,
            asyncHeaderBar(cb) {
                return cb({
                    name: "Email analytics",
                    dates: "now-2w/d_now",
                    datePickerId: "email"
                });
            }
        });
    }, [section, qualifiers]);

    return null;
}
